"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// This file will be modified by the `postinstall` script.
// See postinstall/index.ts for more information.

const defaultValue = {
  config: {
    isInitialized: false
  },
  traits: {}
};
var _default = exports.default = defaultValue;